import { Injectable, Inject } from 'ng-metadata/core';
import {FavoritesService} from '../favorites.service';
import {BriefResultService} from '../../search/briefResult/briefResult.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';

const intersection = require('lodash/intersection');

@Injectable()
export class FavoritesEditLabelsMenuService{
	private PUT_LABELS_URL: string;

    constructor(@Inject('$http') private $http: ng.IHttpService,
				private favoritesService: FavoritesService,
				private briefResultService : BriefResultService,
				@Inject('$state') private $state: ng.ui.IStateService,
				@Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('restBaseURLs') private restBaseURLs) {
        this.PUT_LABELS_URL= restBaseURLs.favoritesBaseURL+'/';
        this.$http = $http;
        this.favoritesService = favoritesService;
	}

	putLabel(recordId, labels) {
		let payload = { 'records': [{ 'recordId': recordId, 'labels': labels }] };
		this.$http.put(this.PUT_LABELS_URL, payload).then(() => {
			this.favoritesService.getItemsFromServer();
		});
	}
    
	putLabels(records) {
		this.$http.put(this.PUT_LABELS_URL, records).then(() => {
			this.favoritesService.getItemsFromServer();
		});
	}

	getRecordsByState() {
		if (this.$state.current.name === STATE_NAMES.SEARCH) {
			return this.briefResultService.getSearchChosenItems();
		} else if (this.$state.current.name === STATE_NAMES.FAVORITES) {
			return this.briefResultService.getChosenRecords();
		}
	}

	getRecordIdByState(records, i) {
		if (this.$state.current.name === STATE_NAMES.SEARCH) {
			return records[i].pnx.control.recordid[0];
		} else if (this.$state.current.name === STATE_NAMES.FAVORITES) {
			return records[i];
		}
	}
	
	returnAssignedLabels(isSection, item ?) {
         if (!isSection) {
           let assignedLabels = this.favoritesService.getLabelsOfRecord(item.pnx.control.recordid[0]);
           return this.sortLables(assignedLabels);
         }
        else {
			let records = this.getRecordsByState();
             let labels = new Set();
             for (let i = 0; i < records.length; i++) {
                 let label = this.favoritesService.getLabelsOfRecord(this.getRecordIdByState(records, i));
                 for (let j = 0; j < label.length; j++) {
                     labels.add(label[j]);
                  }
              }
             let assignedLabels = Array.from(labels);
             return this.sortLables(assignedLabels);
         }
	}

	 returnOtherLabels(isSection, item ?) {
         if (!isSection) {
            let otherLabels = this.favoritesService.getOtherLabels(item.pnx.control.recordid[0]);
             return this.sortLables(otherLabels);
        }
        else {
			let records = this.getRecordsByState();
             let otherLabels = [];
             if(this.favoritesService.getLabels()){
                 otherLabels = Object.keys(this.favoritesService.getLabels());
             }
             for (let i = 0; i < records.length; i++) {
                 let labels = this.favoritesService.getOtherLabels(this.getRecordIdByState(records, i));
                 otherLabels =  intersection(otherLabels, labels);
             }
             return this.sortLables(otherLabels);
         }
	 }
	 
	removeLabelForOneRecord(recordId, label) {
		let labels = this.favoritesService.getLabelsOfRecord(recordId).slice();
		let index = labels.indexOf(label);
		if (index !== -1) {
			labels.splice(index, 1);
			this.putLabel(recordId, labels);
		}
	}
	 
	 removeLabel(label, isSection, item ?){
		 if (!isSection) {
			 let recordId = item.pnx.control.recordid[0];
			 this.removeLabelForOneRecord(recordId, label);
		 }
		 else {
			 let arrayRecords = [];
			 let records = this.getRecordsByState();
			 let payload = {};
			 for (let i = 0; i < records.length; i++) {
				 let labels = this.favoritesService.getLabelsOfRecord(this.getRecordIdByState(records, i)).slice();
				 let index = labels.indexOf(label);
				 if (index !== -1) {
					 labels.splice(index, 1);
					 payload = { 'recordId': this.getRecordIdByState(records, i), 'labels': labels };
					 arrayRecords.push(payload);
				 }
			 }
			 let obj = { 'records': arrayRecords }
			 this.putLabels(obj);
		 }
	 }
	 
	addLabelForOneRecord(recordId, label) {
		let labels = this.favoritesService.getLabelsOfRecord(recordId).slice();
		labels.push(label);
		this.putLabel(recordId, labels);
	}

	addLabel(label, isSection, item ?) {
		if (!isSection) {
           let recordId = item.pnx.control.recordid[0];
           this.addLabelForOneRecord(recordId,label);
		} else {
			let arrayRecords = [];
			let records = this.getRecordsByState();
			let payload = {};
			for (let i = 0; i < records.length; i++) {
				let labels = this.favoritesService.getLabelsOfRecord(this.getRecordIdByState(records, i)).slice();
				labels.push(label);
				payload = { 'recordId': this.getRecordIdByState(records, i), 'labels': labels };
				arrayRecords.push(payload);
			}
			let obj = { 'records': arrayRecords }
			this.putLabels(obj);
		}
	}

	public isChosenFavAndLabels(disable) {
		if (disable) {
			return this.$translate.instant('nui.aria.bulk.addToFavoritesSignedInDisabled');
		}
		else {
			return this.$translate.instant('nui.aria.bulk.addToFavoritesSignedIn');
		}
	}

	 public isChosenLabels(disable) {
        if (disable) {
            return this.$translate.instant('nui.favorites.labelsDisable') +' '+ this.$translate.instant('nui.aria.favorites.enableControls');
        }
        else {
            return this.$translate.instant('nui.favorites.labels');
        }
    }

	public sortLables(lables) {
		return lables ? lables.sort(function (a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); }) : lables;
	}

}





// WEBPACK FOOTER //
// ./src/main/webapp/components/favorites/favoritesEditLabelsMenu/favoritesEditLabelsMenu.service.ts